var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.19 0C26.4677 0 34.0001 7.53237 34.0001 16.8101C34.0001 26.0878 26.4677 33.6202 17.19 33.6202C7.91225 33.6202 0.379883 26.0878 0.379883 16.8101C0.379883 7.53237 7.91225 0 17.19 0ZM11.9344 26.2573V13.1296H7.57007V26.2573H11.9344ZM27.6689 26.2573V18.7291C27.6689 14.6968 25.516 12.8209 22.645 12.8209C20.33 12.8209 19.293 14.0941 18.7124 14.9883V13.1296H14.3492C14.4071 14.3613 14.3492 26.2573 14.3492 26.2573H18.7123V18.9259C18.7123 18.5335 18.7406 18.1412 18.8562 17.8607C19.1711 17.077 19.8896 16.2651 21.095 16.2651C22.6732 16.2651 23.3055 17.4694 23.3055 19.2334V26.2573H27.6689ZM9.78172 6.79955C8.28851 6.79955 7.31293 7.78124 7.31293 9.06793C7.31293 10.3275 8.25883 11.3362 9.72393 11.3362H9.7521C11.2739 11.3362 12.2211 10.3275 12.2211 9.06793C12.1928 7.78124 11.2739 6.79955 9.78172 6.79955Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default "/Frontend/static/media/linkedin.98b57d76c58ed12221f3058004493a81.svg";
export { ForwardRef as ReactComponent };